export default () => {
  if (!Function.prototype.bind) {
    Function.prototype.bind = function (object, ...args) { //eslint-disable-line no-extend-native
      return (...a) => this.apply(object, [...args, ...a])
    }
  }
}


// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/viewer/bindPolyfill.js